import { render, staticRenderFns } from "./MNDetailInfo.vue?vue&type=template&id=2deb1d58&"
import script from "./MNDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./MNDetailInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports